import React from 'react';
import EventBrellaLayout from './EventBrellaLayout';

const EventBrellaPlatform = () => (
  <EventBrellaLayout>
    <section className="pillars-section">
      <div className="wrap">
        <div className="pillars-grid">
          <div className="pillar">
            <div className="mark">1</div>
            <h3>Own the guest list</h3>
            <p>
              Every buyer's email and phone number lands in your system, not a marketplace's. Text them, email them, retarget them — no platform lock-in, no re-buying access to your own crowd.
            </p>
          </div>
          <div className="pillar">
            <div className="mark">2</div>
            <h3>One checkout, not four apps</h3>
            <p>
              Ticket, table or lounge reservation, parking, and on-site tab all live under one QR code. Fewer taps for the guest, fewer tools for you to reconcile after the event.
            </p>
          </div>
          <div className="pillar">
            <div className="mark">3</div>
            <h3>Guests, recognized</h3>
            <p>
              Staff at the door sees who's a regular, what they usually order, and how many events they've attended — before the guest says a word. That's what turns a buyer into a repeat customer.
            </p>
          </div>
        </div>
      </div>
    </section>
  </EventBrellaLayout>
);

export default EventBrellaPlatform;
